import { Popover } from "antd";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";

export const StyledPopover = styled(Popover)``;
